import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { MeetingPreviewComponent } from './pages/meeting-preview/meeting-preview.component';
import { WelcomeComponent } from './pages/welcome/welcome.component';
import { InputOutputSettingsComponent } from './shared/components/input-output-settings/input-output-settings.component';
import { MeetingPageComponent } from './pages/meeting-page/meeting-page.component';
import { EndmeetingComponent } from './pages/endmeeting/endmeeting.component';
import { MeetingPreviewPatientComponent } from './pages/meeting-preview-patient/meeting-preview-patient.component';
import { MeetingPagePatientComponent } from './pages/meeting-page-patient/meeting-page-patient.component';
import { EndmeetingPatientComponent } from './pages/endmeeting-patient/endmeeting-patient.component';

const routes: Routes = [
  { path: 'welcome', component: WelcomeComponent },
  { path: 'vc/:id', component: MeetingPreviewComponent },
  { path: 'patient/:id', component: MeetingPreviewPatientComponent },
  { path: 'settings', component: InputOutputSettingsComponent },
  { path: 'meeting', component: MeetingPageComponent },
  { path: 'meetingpatient', component: MeetingPagePatientComponent },
  { path: 'end', component: EndmeetingComponent },
  { path: 'endpatient', component: EndmeetingPatientComponent },

  { path: '**', component: MeetingPreviewComponent },
]

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, { useHash: true })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
